module.exports = __webpack_public_path__ + "img/laptop-solid.98999e05.svg";